import React from 'react';
import classes from './stars.module.scss';

const Stars: any = ({
  stars,
  reviews,
  fontSize
}: {
  stars: number;
  reviews: number;
  fontSize: number;
}) => {
  if (stars < 0) {
    stars = 0;
  }
  return (
    <div className={classes.stars} style={{ fontSize }}>
      {'★'.repeat(stars) + '☆'.repeat(5 - stars)} <span>({reviews || 0})</span>
    </div>
  );
};

export default Stars;
